<div class="table-responsive" [ngClass]="customClass">
    <table class="data-table">
        <ng-container *ngIf="columns && columns.length > 0; else projectedTable">
            <thead>
                <tr>
                    <th
                        *ngFor="let col of columns"
                        [style.width]="col.width || null"
                        [class.text-center]="col.align === 'center'"
                        [class.text-right]="col.align === 'right'"
                        [ngClass]="col.headerClass || ''"
                    >
                        {{ col.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="data && data.length > 0; else emptyState">
                    <ng-container *ngIf="rowTemplate; else autoRows">
                        <ng-container *ngFor="let item of data; let i = index; trackBy: trackByFn">
                            <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: item, index: i }"></ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-template #autoRows>
                        <tr *ngFor="let item of data; let i = index; trackBy: trackByFn">
                            <td
                                *ngFor="let col of columns"
                                [class.text-center]="col.align === 'center'"
                                [class.text-right]="col.align === 'right'"
                            >
                                <ng-container *ngIf="cellTemplate; else defaultCell">
                                    <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: item, column: col, value: item[col.key], index: i }"></ng-container>
                                </ng-container>
                                <ng-template #defaultCell>
                                    {{ item[col.key] }}
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                </ng-container>

                <ng-template #emptyState>
                    <ng-container *ngIf="emptyTemplate; else defaultEmpty">
                        <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
                    </ng-container>
                    <ng-template #defaultEmpty>
                        <tr>
                            <td [attr.colspan]="columns.length" class="empty-state">
                                <div class="empty-state-wrap">
                                    <div class="empty-icon-wrap">
                                        <span class="material-icons">{{ emptyIcon }}</span>
                                    </div>
                                    <h3 class="empty-title" *ngIf="emptyTitle">{{ emptyTitle }}</h3>
                                    <p class="empty-desc" *ngIf="emptyDescription">{{ emptyDescription }}</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </ng-template>
            </tbody>
        </ng-container>

        <ng-template #projectedTable>
            <ng-content></ng-content>
        </ng-template>
    </table>
</div>